// Module
var code = "<h2 id=\"how-to-change-your-due-date\">How to Change Your Due Date</h2> <p>Sign in to Account Access to change your due date.</p> ";
// Exports
export default code;